import { Trans } from '@lingui/macro';
import * as React from 'react';

export const inputNotInTheFutureErrorMessage = (
  <Trans>
    Ce champ doit posséder une date dans le futur
  </Trans>
);
